export const SHOW_LIMIT_EXCEEDED_TYPE = "limit-exceeded-error";
